import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop";

// account / orders overview
import AccountLogin from "./views/account/AccountLogin";
import AccountUsername from "./views/account/AccountUsername";
import AccountConfirmationCode from "./views/account/AccountConfirmationCode";
import AccountRegistration from "./views/account/AccountRegistration";
import PasswordReset from "./views/account/PasswordReset";
import Profile from "./views/account/Profile";
import Orders from "./views/account/Orders";
import OrderOverview from "./views/account/OrderOverview";

// booking steps
import Home from "./views/Home";
import Tickets from "./views/Step10_Tickets";
import AddonsBirthday from "./views/Step20_AddOns_Birthday";
import Addons from "./views/Step20_AddOns";
import Calendar from "./views/Step30_Calendar";
import Summary from "./views/Step35_Summary";
import Username from "./views/Step40_Username";
import Login from "./views/Step50_Login";
import ConfirmationCode from "./views/Step45_ConfirmationCode";
import Registration from "./views/Step50_Registration";
import Information from "./views/Step60_Information";
import Checkout from "./views/Step70_Checkout";
import Confirmation from "./views/Step80_Confirmation";

import "./css/style.css";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>

                {/* account / orders overview */}
                <Route path="/:language/account-username" element={<AccountUsername />} />
                <Route path="/:language/account-confirmation-code" element={<AccountConfirmationCode />} />
                <Route path="/:language/account-registration" element={<AccountRegistration />} />
                <Route path="/:language/account-login" element={<AccountLogin />} />
                <Route path="/:language/account-login/:isEmailResetSuccess" element={<AccountLogin />} />
                <Route path="/:language/password-reset/:redirectUrl" element={<PasswordReset />} />
                <Route path="/:language/profile" element={<Profile />} />
                <Route path="/:language/orders" element={<Orders />} />
                <Route path="/:language/order-overview/:orderId" element={<OrderOverview />} />

                {/* booking steps */}
                <Route path="/" element={<Navigate to="/de/home" replace />} />
                <Route path="/:language/home" element={<Home />} />
                <Route path="/:language/tickets/:bookingType" element={<Tickets />} />
                <Route path="/:language/addons-birthday" element={<AddonsBirthday />} />
                <Route path="/:language/addons" element={<Addons />} />
                <Route path="/:language/summary" element={<Summary />} />
                <Route path="/:language/calendar" element={<Calendar />} />
                <Route path="/:language/username" element={<Username />} />
                <Route path="/:language/confirmation-code" element={<ConfirmationCode />} />
                <Route path="/:language/login" element={<Login />} />
                <Route path="/:language/registration" element={<Registration />} />
                <Route path="/:language/information" element={<Information />} />
                <Route path="/:language/checkout" element={<Checkout />} />
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />

            </Routes>
        </BrowserRouter>
    );
}

export default App;
